import { Flex } from "antd";
import styled from "styled-components";

export const FormWrap = styled.div`
  max-height: 80vh;
  overflow-y: auto;
`;

export const ModalTitleWrap = styled(Flex)`
  & .right-action--wrap {

  }
`